import { createFileRoute } from '@tanstack/react-router'
import { insureSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/insure/vessel-filter')({
  validateSearch: (search) => insureSearchSchema.parse(search),
  loaderDeps: () => ({}),
})
